module.exports = __webpack_public_path__ + "static/img/avatar_light.fe808c44.svg";